import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { MdsCheckboxComponent } from '@medpacesoftwaredevelopment/designsystem';
import { BookableCaregiver, CheckboxFormGroup } from '../../form-groups/travel-request-card.formgroup';

@Component({
    selector: 'medpace-caregiver-checkbox-option-edit',
    imports: [MdsCheckboxComponent],
    templateUrl: './caregiver-checkbox-option-edit.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaregiverCheckboxOptionEditComponent {
    public readonly formGroup: InputSignal<CheckboxFormGroup<BookableCaregiver | null>> = input.required();
    public readonly isPrimary: InputSignal<boolean> = input(false);

    public readonly label: Signal<string> = computed(() => {
        const caregiverPrefix = this.isPrimary() ? 'Primary Caregiver' : 'Caregiver';
        const caregiver = this.formGroup().getRawValue().value?.caregiver;
        const caregiverFullName = caregiver
            ? [caregiver.firstName, caregiver.middleName, caregiver.lastName].filter((name) => !!name).join(' ')
            : '';

        return caregiverPrefix + ' ' + caregiverFullName;
    });
}
